/* eslint-disable simple-import-sort/imports */
import React from 'react'

import { COLORS } from '../../theme/colors'
import { MsdkComponent } from '../../utils'
import { ButtonAlignProps } from './ButtonAlignProps'
import { ButtonBase } from './ButtonBase'
import { createComponentWrapperWithRef, styled } from '../../theme'
/* eslint-enable simple-import-sort/imports */

const MuiStyledButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  background-color: ${COLORS.button.main};
  border-radius: 20px;
  box-shadow: unset;
  padding: 8px 24px;
  height: 40px;
  font-size: 0.938rem;
  font-weight: 700;
  line-height: 160%;
  text-transform: unset;
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}

  &:hover {
    background-color: ${COLORS.button.dark};
    box-shadow: unset;
  }

  &:disabled {
    background-color: ${COLORS.action.diasbeldBackround};
    color: ${COLORS.action.disabled};
    box-shadow: unset;
  }
`

const NovaStyledButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}
`

const StyledButton = createComponentWrapperWithRef(
  {
    mui: MuiStyledButton,
    nova: NovaStyledButton,
  },
  'StyledButtonPrimary',
)

export function ButtonPrimary({ alignLeft, ...props }: ButtonAlignProps): MsdkComponent {
  return (
    <StyledButton $alignLeft={alignLeft} variant="contained" {...props}>
      {props.children}
    </StyledButton>
  )
}
